import React, { Component } from "react";
import ReactTable from "react-table";

class AdminTable extends Component {
  render() {
    const isAdmin = JSON.parse(localStorage.getItem("role")).some(
      r => r.name === "ROLE_ADMIN"
    );
    let users = this.props.users.slice();
    const columns = [
      {
        Header: "User ID",
        accessor: "id",
        width: 70,
        show: false
      },
      { Header: "Full Name", accessor: "name" },
      { Header: "Username", accessor: "username" },
      { Header: "Email", accessor: "email" },
      {
        Header: "Roles",
        accessor: "roles",
        Cell: props =>
          props.original.roles
            .map(x => x.name.replace("ROLE_", ""))
            .sort()
            .toString(),
        filterMethod: (filter, row) => {
          console.log(row[filter.id]);
          return row[filter.id].find(role =>
            role.name.includes(filter.value.toUpperCase())
          );
        }
      },
      {
        Header: "States",
        accessor: "states",
        Cell: props =>
            props.original.states
                .map(x => x.state_name)
                .sort()
                .toString(),
        filterMethod: (filter, row) => {
          console.log(row[filter.id]);
          return row[filter.id].find(state =>
              state.state_name.toLowerCase().includes(filter.value.toLowerCase())
          );
        }
      },
      {
        Header: "Actions",
        // accessor: "roles"
        filterable: false,
        sortable: false,
        Cell: props =>
          isAdmin ? (
            <div className="text-center">
              <button
                className="btn btn-outline-primary btn-sm btn-outline"
                onClick={this.props.toggleRoleModal}
              >
                Change Role
              </button>{" "}
              {/* <button
              className="btn btn-outline-danger btn-sm"
              onClick={this.props.togglePasswordModal}
            >
              Change Password
            </button> */}
              <button
                  className="btn btn-outline-primary btn-sm btn-outline"
                  onClick={this.props.toggleStateModal}
              >
                Change States
              </button>
            </div>
          ) : (
            <div className="text-center">None</div>
          )
      }
    ];
    columns.forEach(h => (h.headerStyle = { fontWeight: "bold" }));
    let filterCaseInsensitive = (filter, row) => {
      const id = filter.pivotId || filter.id;
      return row[id]
        ? String(row[id])
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : false;
    };
    return (
      <ReactTable
        className="-highlight my-1"
        data={users}
        columns={columns}
        filterable
        defaultFilterMethod={(filter, row) =>
          filterCaseInsensitive(filter, row)
        }
        onFilteredChange={filters => {
          console.log(filters);
          localStorage.setItem("admin_filters", JSON.stringify(filters));
        }}
        defaultFiltered={
          JSON.parse(localStorage.getItem("admin_filters")) || []
        }
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              if (rowInfo && isAdmin) this.props.clicked(rowInfo.row.id);
            }
          };
        }}
      />
    );
  }
}

export default AdminTable;
